export const CLIENT_ID = window.__active_app_env.REACT_APP_CLIENT_ID;
export const CLIENT_SECRET_ID = window.__active_app_env.REACT_APP_CLIENT_SECRET_ID
export const ISSUER_URI = window.__active_app_env.REACT_APP_DEX_API;
export const REDIRECT_URI = `${window.location.origin}/callback`;

export const oauth_dev = {
    clientId: CLIENT_ID,
    clientSecret: CLIENT_SECRET_ID,
    OPServer: ISSUER_URI,
    redirectURL: REDIRECT_URI,
    scope: 'openid profile email offline_access groups',
    userInfoEndpoint: '/userinfo',
    extra: { prompt: 'consent', access_type: 'offline' }
};
